import { useState, useContext } from "react";
import { editClientFromDatabase } from "../../../data/clients/repository/ClientsRepository";
import { ClientContext } from "../../../context/ClientContext";
import { formatCPFOrCNPJ, formatPhone } from "../../../utils/FormatUtils";

export function useEditClient(closeModal) {
  const { selectedClient, editClient } = useContext(ClientContext);
  const [code, setCode] = useState(selectedClient?.code || "");
  const [name, setName] = useState(selectedClient?.name || "");
  const [cnpj, setCnpj] = useState(selectedClient?.cnpj || "");
  const [email, setEmail] = useState(selectedClient?.email || "");
  const [phone, setPhone] = useState(selectedClient?.phone || "");

  const handleCode = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setCode(value);
  };

  const handleName = (e) => {
    setName(e.target.value);
  };

  const handleCnpj = (e) => {
    setCnpj(formatCPFOrCNPJ(e.target.value));
  };

  const handleEmail = (e) => {
    setEmail(e.target.value);
  };

  const handlePhone = (e) => {
    setPhone(formatPhone(e.target.value));
  };

  const onEditClick = async (e) => {
    e.preventDefault();
    const clientData = {
      code,
      name,
      cnpj,
      email,
      phone
    };

    try {
      const response = await editClientFromDatabase(selectedClient?.id, clientData);
      if (response) {
        editClient(true);
        closeModal();
      } else {
        editClient(false);
        console.error("Failed to edit the Client.");
      }
    } catch (error) {
      editClient(false);
      console.error("Error editing client:", error);
    }
  };

  const isFormValid = code && name && cnpj && email && phone;
  return {
    code,
    name,
    cnpj,
    email,
    phone,
    handleCode,
    handleName,
    handleCnpj,
    handleEmail,
    handlePhone,
    onEditClick,
    isFormValid
  };
}